import React from 'react';
import { View, StyleSheet } from 'react-native';
import {
  SkeletonGroup,
  SkeletonBone,
} from '@/components/common/skeleton';
import { useThemeColors } from '@/hooks/residents/useThemeColors';

export const MobilePaymentCardLightSkeleton: React.FC = () => {
  const { components } = useThemeColors();

  return (
  <SkeletonGroup>
    <View style={[styles.card, { backgroundColor: components.card.background }]}>
      <View style={styles.cardContent}>
        {/* Header */}
        <View style={styles.header}>
          <View style={styles.headerLeft}>
            <SkeletonBone width={120} height={20} style={{ marginBottom: 8 }} />
            <SkeletonBone width={180} height={14} />
          </View>
          <SkeletonBone width={70} height={24} borderRadius={12} />
        </View>

        {/* Balance */}
        <View style={styles.balanceSection}>
          <SkeletonBone width={100} height={32} style={{ marginBottom: 4 }} />
          <SkeletonBone width={80} height={14} />
        </View>

        {/* Button */}
        <SkeletonBone width="100%" height={44} borderRadius={8} />
      </View>
    </View>
  </SkeletonGroup>
  );
};

export default MobilePaymentCardLightSkeleton;

const styles = StyleSheet.create({
  card: {
    borderRadius: 12,
    marginHorizontal: 16,
    marginVertical: 6,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.06,
    shadowRadius: 2,
    elevation: 2,
    overflow: 'hidden',
  },
  cardContent: {
    padding: 16,
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: 12,
  },
  headerLeft: {
    flex: 1,
    marginRight: 12,
  },
  balanceSection: {
    marginBottom: 12,
  },
});
